/**
 * TERRA Observations — cross-product persistent memory.
 *
 * Products call listObservations() on dashboard mount to show
 * "TERRA noticed..." cards. Users dismiss via acknowledgeObservation().
 */
import { apiClient } from './client';

export interface TerraObservation {
  id: string;
  product: string;
  site_id: string | null;
  site_name: string | null;
  subject: string;
  observation: string;
  tags: string[];
  confidence: number;
  related_entity_type: string | null;
  related_entity_id: string | null;
  source_tool: string | null;
  acknowledged: boolean;
  created_at: string;
  acknowledged_at: string | null;
}

export interface ObservationListParams {
  site_id?: string;
  product?: string;
  tag?: string;
  related_entity_type?: string;
  related_entity_id?: string;
  include_acknowledged?: boolean;
  limit?: number;
}

export async function listObservations(
  params: ObservationListParams = {},
): Promise<TerraObservation[]> {
  const resp = await apiClient.get<TerraObservation[]>('/terra/observations', { params });
  return resp.data;
}

export async function acknowledgeObservation(
  observationId: string,
  body: { acknowledgement?: string; superseded_by?: string } = {},
): Promise<{ status: string; observation_id: string }> {
  const resp = await apiClient.patch(
    `/terra/observations/${observationId}/acknowledge`,
    body,
  );
  return resp.data;
}
